export default __webpack_public_path__ + "static/media/H0005.e7116d95.png";